import { useMemo } from 'react';
import { WidgetConfiguration } from 'framework';

export type ButtonMode =
  | 'fitTextMode'
  | 'fillParentMode'
  | 'buttonLessMode'
  | 'buttonAndResultMode';

export function useButtonMode(
  widgetConfiguration: WidgetConfiguration
): ButtonMode {
  const buttonMode = useMemo<ButtonMode>(() => {
    if (widgetConfiguration.buttonless) {
      return 'buttonLessMode';
    }
    if (
      widgetConfiguration.buttonFillParent &&
      !widgetConfiguration.showButtonAndResult
    ) {
      return 'fillParentMode';
    }
    if (
      widgetConfiguration.buttonFillParent &&
      widgetConfiguration.showButtonAndResult
    ) {
      return 'buttonAndResultMode';
    }
    if (
      !widgetConfiguration.buttonFillParent &&
      !widgetConfiguration.showButtonAndResult
    ) {
      return 'fitTextMode';
    }
    return 'fitTextMode';
  }, [
    widgetConfiguration.buttonFillParent,
    widgetConfiguration.showButtonAndResult,
    widgetConfiguration.buttonless
  ]);

  return buttonMode;
}
